import React, { useEffect } from 'react';

import QuestionShell from '../QuestionShell';
import useQuestionForm from '../QuestionShell/useQuestionForm';

function Time({
  identifier, pages, info, handleDeleteQuestion, handleDuplicateQuestion,
  mode,
}) {
  const question = useQuestionForm({
    identifier,
    pages,
    info,
    autoLoadMedia: false,
  });
  const { loadMedia } = question;

  // A diferencia del resto de los tipos, acá la carga es reactiva a `pages`. No
  // hace falta guard porque los setters de `loadMedia` son idempotentes: antes el
  // guard miraba sólo la imagen y dejaba sin cargar los emails de las preguntas
  // que no tenían una.
  useEffect(() => {
    loadMedia(info || pages?.[identifier - 1]);
  }, [identifier, info, pages, loadMedia]);

  return (
    <QuestionShell
      {...question}
      identifier={identifier}
      info={info}
      mode={mode}
      titleKey="task.taskEdition.dateAnswerText.question"
      descriptionKey="task.taskEdition.dateAnswerText.description"
      descriptionAs="text"
      // TODO: el campo lee siempre desde la pregunta, así que no refleja lo que
      // se tipea hasta que el padre re-renderiza. Se mantiene tal cual estaba;
      // para arreglarlo basta con sacar esta prop y usar el estado del hook.
      descriptionValue={info ? info.description : pages?.[identifier - 1]?.description}
      handleDeleteQuestion={handleDeleteQuestion}
      handleDuplicateQuestion={handleDuplicateQuestion}
    />
  );
}

export default Time;
